import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./OrgProducts.css";

import Util from "../../util/util";

class OrgProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_id: "",
      usersData: localStorage.getItem("user_data")
        ? JSON.parse(localStorage.getItem("user_data"))
        : {},
      userProducts: [],
      //filteredProducts: 0,
      sentProducts: [],
      currentFilter: "all",
      selectAll: false,
      selectAny: false,
      allSelected: false,
      promotedError: "",
      isVisibleError: true,
      autoRenew: false,
      page_number: 0,
      max_page: 0,
      pages_count: [],
      loading_products: true,
    };

    this.reloadTimeout = false;
  }

  componentDidMount = () => {
    document.title = this.props.pageTitle;
    this.checkFilters(this.state.currentFilter);
  };

  loadAllProducts = (pageNumber, filter) => {
    var mainThis = this;
    axios
      .post(window.ajaxLink + "products/userproducts", {
        page_number: pageNumber,
        current_filter: filter,
      })
      .then((res) => {
        mainThis.setState({
          userProducts: res["data"]["responseData"]["user_products"],
          autoRenew: res["data"]["responseData"]["auto_renew"],
          pages_count: res["data"]["responseData"]["pages_count"],
          max_page: res["data"]["responseData"]["last_page"],
          selectAll: false,
          selectAny: false,
          loading_products: false,
        });
        //mainThis.checkSelectedLength();
      })
      .catch((err) => {});
  };

  checkSelectedLength = () => {
    var checkArr = this.state.userProducts.filter(
      (checkBox) => checkBox.checked
    );
    if (this.state.userProducts.length == checkArr.length) {
      this.setState({ allSelected: true });
    } else {
      this.setState({ allSelected: false });
    }
  };

  checkAll = () => {
    this.setState({
      selectAll: !this.state.selectAll,
      selectAny: !this.state.selectAll,
    });
    var filter = this.state.currentFilter;

    if (filter == "all") {
      var allItems = this.state.userProducts;
      allItems.map(
        (checkItems, i) => (allItems[i].checked = !this.state.selectAll)
      );
      this.setState({ userProducts: allItems });
    }
    if (filter == "expired") {
      var expired = this.state.userProducts.filter(
        (singleItem) => singleItem.expired
      );
      expired.map(
        (checkItems, i) => (expired[i].checked = !this.state.selectAll)
      );
    }
    if (filter == "no-quantity") {
      var noquantity = this.state.userProducts.filter(
        (singleItem) => singleItem.quantity == 0
      );
      noquantity.map(
        (checkItems, i) => (noquantity[i].checked = !this.state.selectAll)
      );
    }

    this.checkSelectedLength();
  };

  uncheckAll = () => {
    this.setState({ selectAll: false, selectAny: false });
    var allItems = this.state.userProducts;
    allItems.map((checkItems, i) => (allItems[i].checked = false));
    this.setState({ userProducts: allItems });
    this.checkSelectedLength();
  };

  getCheckBox = (i) => {
    var checkBox = this.state.userProducts;
    checkBox[i]["checked"] = !checkBox[i]["checked"];
    var anyTrue = checkBox.filter((checkBox) => checkBox.checked);

    if (anyTrue.length > 0) {
      anyTrue = true;
    } else {
      anyTrue = false;
    }
    this.setState({ userProducts: checkBox, selectAny: anyTrue });
    this.checkSelectedLength();
  };

  promoteAd = (itemP) => {
    this.setState({
      promotedError: "",
      isVisibleError: false,
    });

    var isValid = true;
    if (itemP["quantity"] < 1) {
      isValid = false;
      this.setState({
        isVisibleError: true,
        promotedError:
          "Ovaj proizvod ne može biti promovisan jer ga nema na stanju",
      });
    }

    if (itemP["expired"]) {
      isValid = false;
      this.setState({
        isVisibleError: true,
        promotedError: "Ovaj proizvod ne može biti promovisan jer je istekao",
      });
    }

    if (isValid == true && itemP.is_promoted == 0) {
      this.setState({ loading_products: true });
      var mainThis = this;
      axios.defaults.headers.common["Authorization"] =
        this.state.usersData.token;
      axios
        .post(window.ajaxLink + "products/promoteAd", {
          product_id: itemP["product_id"],
        })
        .then((res) => {
          mainThis.loadAllProducts(
            this.state.page_number,
            this.state.currentFilter
          );
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  addQuantity = (i) => {
    var quantity = this.state.userProducts;
    quantity[i]["quantity"]++;
    this.setState({ userProducts: quantity });

    var mainThis = this;

    if (mainThis.reloadTimeout) {
      clearTimeout(mainThis.reloadTimeout);
    }
    axios.defaults.headers.common["Authorization"] = this.state.usersData.token;
    axios
      .post(window.ajaxLink + "products/sendproducts", {
        changeQuantity: 1,
        productId: quantity[i].product_id,
        quantity: quantity[i].quantity,
      })
      .then((res) => {
        var allItems = mainThis.state.userProducts;
        mainThis.state.userProducts.map(
          (checkItems, i) => (allItems[i].checked = false)
        );
        mainThis.setState({
          userProducts: allItems,
          selectAll: false,
          selectAny: false,
        });

        if (mainThis.reloadTimeout) {
          clearTimeout(mainThis.reloadTimeout);
        }
        mainThis.reloadTimeout = setTimeout(() => {
          mainThis.loadAllProducts(
            this.state.page_number,
            this.state.currentFilter
          );
        }, 2000);
      })
      .catch((err) => {});
  };

  updateQuantity = (event, i) => {
    var quantity = this.state.userProducts;
    quantity[i]["quantity"] = event.target.value;
    this.setState({ userProducts: quantity });

    if (
      quantity[i]["quantity"] !== "" &&
      parseInt(quantity[i]["quantity"]) !== 0
    ) {
      var mainThis = this;

      if (mainThis.reloadTimeout) {
        clearTimeout(mainThis.reloadTimeout);
      }
      axios.defaults.headers.common["Authorization"] =
        this.state.usersData.token;
      axios
        .post(window.ajaxLink + "products/sendproducts", {
          changeQuantity: 1,
          productId: quantity[i].product_id,
          quantity: quantity[i].quantity,
        })
        .then((res) => {
          //this.divToInput(i);
          var allItems = mainThis.state.userProducts;
          mainThis.state.userProducts.map(
            (checkItems, i) => (allItems[i].checked = false)
          );
          mainThis.setState({
            userProducts: allItems,
            selectAll: false,
            selectAny: false,
          });

          if (mainThis.reloadTimeout) {
            clearTimeout(mainThis.reloadTimeout);
          }
          mainThis.reloadTimeout = setTimeout(() => {
            mainThis.loadAllProducts(
              this.state.page_number,
              this.state.currentFilter
            );
          }, 2000);
        })
        .catch((err) => {});
    }
  };

  removeQuantity = (i) => {
    var quantity = this.state.userProducts;
    if (quantity[i]["quantity"] > 0) {
      quantity[i]["quantity"]--;
      this.setState({ userProducts: quantity });

      var mainThis = this;

      if (mainThis.reloadTimeout) {
        clearTimeout(mainThis.reloadTimeout);
      }
      axios.defaults.headers.common["Authorization"] =
        this.state.usersData.token;
      axios
        .post(window.ajaxLink + "products/sendproducts", {
          changeQuantity: 1,
          productId: quantity[i].product_id,
          quantity: quantity[i].quantity,
        })
        .then((res) => {
          var allItems = mainThis.state.userProducts;
          mainThis.state.userProducts.map(
            (checkItems, i) => (allItems[i].checked = false)
          );
          mainThis.setState({
            userProducts: allItems,
            selectAll: false,
            selectAny: false,
          });

          if (mainThis.reloadTimeout) {
            clearTimeout(mainThis.reloadTimeout);
          }
          mainThis.reloadTimeout = setTimeout(() => {
            mainThis.loadAllProducts(
              this.state.page_number,
              this.state.currentFilter
            );
          }, 2000);
        })
        .catch((err) => {});
    }
  };

  renewAdd = () => {
    var sendObjs = [];
    this.state.userProducts.map(
      (checkedItem, i) =>
        checkedItem.checked && sendObjs.push(checkedItem.product_id)
    );

    if (sendObjs.length > 0) {
      this.setState({ loading_products: true });
      var mainThis = this;
      axios.defaults.headers.common["Authorization"] =
        this.state.usersData.token;
      axios
        .post(window.ajaxLink + "products/sendproducts", {
          renewAdd: 1,
          sentProducts: sendObjs,
          allProdsSelected: this.state.allSelected,
          current_filter: this.state.currentFilter,
        })
        .then((res) => {
          var allItems = mainThis.state.userProducts;
          mainThis.state.userProducts.map(
            (checkItems, i) => (allItems[i].checked = false)
          );
          mainThis.setState({
            userProducts: allItems,
            selectAll: false,
            selectAny: false,
          });
          mainThis.loadAllProducts(
            this.state.page_number,
            this.state.currentFilter
          );
        })
        .catch((err) => {});
    }
    /*else
				{
					Util.showPopupDialog(
									'Obnova proizvoda',
									'Niste izabrali nijedan proizvod!',
									{title: 'Zatvori', css: 'middle_popup_blue_button', callback: () => { }},
									{title: '', css: '', callback: () => { }},
									() => { },
									'warning_popup');
				}*/
  };

  removeAdd = (prodId) => {
    Util.showPopupDialog(
      "Potvrdite Brisanje",
      "Da li ste sigurni da želite da obrišete ovaj proizvod?",
      {
        title: "Obriši",
        css: "middle_popup_blue_button",
        callback: () => {
          this.removeAddConfirmed(prodId);
        },
      },
      {
        title: "Prekini",
        css: "middle_popup_yellow_button",
        callback: () => {},
      },
      () => {},
      "warning_popup"
    );
  };

  removeAddConfirmed = (prodId) => {
    this.setState({ loading_products: true });
    var mainThis = this;
    axios
      .post(window.ajaxLink + "products/deleteproduct", { product_id: prodId })
      .then((res) => {
        var allItems = mainThis.state.userProducts;
        mainThis.state.userProducts.map(
          (checkItems, i) => (allItems[i].checked = false)
        );
        mainThis.setState({
          userProducts: allItems,
          selectAll: false,
          selectAny: false,
        });
        mainThis.loadAllProducts(
          this.state.page_number,
          this.state.currentFilter
        );
      })
      .catch((err) => {});
  };

  removeAllSelected = () => {
    var sendObjs = [];
    this.state.userProducts.map(
      (checkedItem, i) =>
        checkedItem.checked && sendObjs.push(checkedItem.product_id)
    );

    if (sendObjs.length > 0) {
      var insertText = "";
      if (this.state.currentFilter == "expired") {
        insertText = " koji su istekli";
      } else if (this.state.currentFilter == "no-quantity") {
        insertText = " kojih nema na stanju";
      }

      Util.showPopupDialog(
        "Potvrdite Brisanje",
        "Da li ste sigurni da želite da obrišete " +
          (!this.state.allSelected
            ? "SVE IZABRANE proizvode na ovoj stranici?"
            : "SVE proizvode na ovoj radnji" + insertText + "?"),
        {
          title: "Obriši",
          css: "middle_popup_blue_button",
          callback: () => {
            this.removeAddConfirmedAll(sendObjs);
          },
        },
        {
          title: "Prekini",
          css: "middle_popup_yellow_button",
          callback: () => {},
        },
        () => {},
        "warning_popup"
      );
    }
  };

  removeAddConfirmedAll = (sendObjs) => {
    this.setState({ loading_products: true });
    var mainThis = this;
    axios
      .post(window.ajaxLink + "products/deleteproduct", {
        multiple_products: sendObjs,
        allProdsSelected: this.state.allSelected,
        current_filter: this.state.currentFilter,
      })
      .then((res) => {
        var allItems = mainThis.state.userProducts;
        mainThis.state.userProducts.map(
          (checkItems, i) => (allItems[i].checked = false)
        );
        mainThis.setState({
          userProducts: allItems,
          selectAll: false,
          selectAny: false,
        });
        mainThis.loadAllProducts(
          this.state.page_number,
          this.state.currentFilter
        );
      })
      .catch((err) => {});
  };

  /*checkFilters = (filter) =>
		{
			if ( filter == 'all' )
				{
					this.setState({filteredProducts: this.state.userProducts.length});
				}
			if ( filter == 'expired' )
				{
					var expired = this.state.userProducts.filter(singleItem => singleItem.expired);
					var expiredProducts = expired.length;
					this.setState({filteredProducts: expiredProducts});
				}
			if ( filter == 'no-quantity' )
				{
					var noquantity = this.state.userProducts.filter(singleItem => singleItem.quantity == 0);
					var noquantityProducts = noquantity.length;
					this.setState({filteredProducts: noquantityProducts});
				}
		}*/

  checkFilters = (filter) => {
    if (filter == "all" || filter == "expired" || filter == "no-quantity") {
      this.setState({ page_number: 0, loading_products: true });
      this.loadAllProducts(0, filter);
    }
  };

  checkRenew = (auto_renew) => {
    this.setState({ autoRenew: auto_renew });
    var mainThis = this;

    if (mainThis.reloadTimeout) {
      clearTimeout(mainThis.reloadTimeout);
    }
    axios.defaults.headers.common["Authorization"] = this.state.usersData.token;
    axios
      .post(window.ajaxLink + "user/setAutoRenew", { autoRenew: auto_renew })
      .then((res) => {
        var allItems = mainThis.state.userProducts;
        mainThis.state.userProducts.map(
          (checkItems, i) => (allItems[i].checked = false)
        );
        mainThis.setState({
          userProducts: allItems,
          selectAll: false,
          selectAny: false,
        });

        if (mainThis.reloadTimeout) {
          clearTimeout(mainThis.reloadTimeout);
        }
        mainThis.reloadTimeout = setTimeout(() => {
          mainThis.loadAllProducts(
            this.state.page_number,
            this.state.currentFilter
          );
        }, 2000);
      })
      .catch((err) => {});
  };

  switchPage = (sendVal) => {
    var pageNumber = this.state.page_number;
    if (sendVal == "add") {
      this.setState({ page_number: pageNumber + 1 });
      this.loadAllProducts(pageNumber + 1, this.state.currentFilter);
    } else if (sendVal == "substract") {
      this.setState({ page_number: pageNumber - 1 });
      this.loadAllProducts(pageNumber - 1, this.state.currentFilter);
    } else {
      this.setState({ page_number: sendVal });
      this.loadAllProducts(sendVal, this.state.currentFilter);
    }
  };

  setSold = (single_item) => {
    if (single_item["product_id"] != 0) {
      var mainThis = this;
      axios.defaults.headers.common["Authorization"] =
        this.state.usersData.token;
      axios
        .post(window.ajaxLink + "products/setSold", {
          productId: single_item["product_id"],
        })
        .then((res) => {
          mainThis.loadAllProducts(
            this.state.page_number,
            this.state.currentFilter
          );
        })
        .catch((err) => {});
    }
  };

  render() {
    return (
      <div className="org_products_container">
        <div className="org_products_page_title">Organizator</div>
        <div className="org_products_top_buttons_container">
          {(this.state.selectAny || this.state.selectAll) && (
            <div className="org_products_top_content_container">
              <div className="org_products_button" onClick={this.renewAdd}>
                Obnovi Izabrane
              </div>
              <div
                className="org_products_button org_products_button_adj"
                onClick={this.removeAllSelected}
              >
                Obriši Izabrane
              </div>
            </div>
          )}
          <div
            className={
              "org_products_top_content_container org_products_top_content_right" +
              (!this.state.selectAny && !this.state.selectAll
                ? " org_products_top_content_no_buttons"
                : "")
            }
          >
            <div className="org_products_auto_renew">
              <div
                className={
                  "org_products_checkbox" +
                  (this.state.autoRenew
                    ? " org_products_checkbox_selected"
                    : "")
                }
                onClick={() => this.checkRenew(!this.state.autoRenew)}
              ></div>
              <div className="org_products_auto_renew_text">
                Automatsko obnavljanje
              </div>
            </div>
          </div>
        </div>
        <div className="org_tabs" onClick={this.uncheckAll}>
          <div
            className={this.state.currentFilter == "all" ? "active" : ""}
            onClick={() => {
              this.setState({ currentFilter: "all" });
              this.checkFilters("all");
            }}
          >
            SVI
          </div>
          <div
            className={this.state.currentFilter == "expired" ? "active" : ""}
            onClick={() => {
              this.setState({ currentFilter: "expired" });
              this.checkFilters("expired");
            }}
          >
            ISTEKLI
          </div>
          <div
            className={
              this.state.currentFilter == "no-quantity" ? "active" : ""
            }
            onClick={() => {
              this.setState({ currentFilter: "no-quantity" });
              this.checkFilters("no-quantity");
            }}
          >
            NEMA NA STANJU
          </div>
        </div>
        {this.state.userProducts.length > 0 ? (
          <div className="org_products_select_all_container">
            <div
              className={
                "org_products_checkbox" +
                (this.state.selectAll ? " org_products_checkbox_selected" : "")
              }
              onClick={this.checkAll}
            ></div>
            <div
              className="org_products_select_all_text"
              onClick={this.checkAll}
            >
              Označi sve
            </div>
          </div>
        ) : (
          <div className="org_products_select_all_container">
            <div
              style={{ textAlign: "center", padding: "40px 0" }}
              className="org_single_item_title"
            >
              Nema rezultata
            </div>
          </div>
        )}
        {this.state.userProducts.map(
          (singleItem, i) => (
            //this.state.currentFilter == 'all' || ( this.state.currentFilter == 'expired' && singleItem.expired == true ) || ( this.state.currentFilter == 'no-quantity' && singleItem.quantity == 0 ) ?
            <div
              key={i}
              className={
                "org_products_single_item " +
                (singleItem.quantity == 0 ? " org_warning" : "") +
                (singleItem.checked ? " org_checked" : "")
              }
            >
              <div
                className={
                  "org_single_item_title" +
                  (singleItem.quantity > 0 &&
                  !singleItem.expired &&
                  singleItem.image
                    ? " org_toptitle_promoted"
                    : "")
                }
              >
                <div
                  className={
                    "org_products_checkbox org_single_item_checkbox_container_mobile " +
                    (singleItem.checked
                      ? " org_products_checkbox_selected"
                      : "")
                  }
                  onClick={() => {
                    this.getCheckBox(i);
                  }}
                ></div>
                {singleItem.name}
              </div>
              {singleItem.quantity > 0 &&
                !singleItem.expired &&
                singleItem.image != "" && (
                  <div className="org_single_item_promoted_container">
                    <div
                      className={
                        "org_single_item_promote_btn" +
                        (singleItem.is_promoted == 1
                          ? " org_promotedproduct"
                          : "")
                      }
                      onClick={() => {
                        this.promoteAd(singleItem);
                      }}
                    >
                      {singleItem.is_promoted == 0 ? "Promoviši" : "Promovisan"}
                    </div>
                  </div>
                )}
              <div>
                <div className="org_single_item_box org_single_item_checkbox_container">
                  <div
                    key={i}
                    onClick={() => {
                      this.getCheckBox(i);
                    }}
                  >
                    <div
                      className={
                        "org_products_checkbox" +
                        (singleItem.checked
                          ? " org_products_checkbox_selected"
                          : "")
                      }
                    ></div>
                  </div>
                </div>
                <div className="org_single_item_box">
                  <div
                    className="org_single_item_picture"
                    style={{
                      backgroundImage: singleItem.image
                        ? "url(" + singleItem.image + ")"
                        : "",
                    }}
                  ></div>
                </div>
                <div className="org_single_item_box">
                  <div className="org_single_item_header org_single_item_header_adjust">
                    Cijena
                  </div>
                  <div className="org_single_item_value org_single_item_value_price">
                    {Util.formatPrice(singleItem.price)}
                  </div>
                </div>
                <div className="org_single_item_box">
                  <div className="org_single_item_header org_single_item_header_adjust">
                    Obnovljeno
                  </div>
                  <div
                    className={
                      "org_single_item_value" +
                      (singleItem.expired ? " org_expired_warning" : "") +
                      (singleItem.expires_soon && !singleItem.expired
                        ? " org_expires_soon_warning"
                        : "")
                    }
                  >
                    {Util.dateTimeFormat(singleItem.time)}
                    <div className="org_single_item_expire">
                      {Util.timeUntilGet(singleItem.time_expire) == "expired"
                        ? "Isteklo"
                        : "Ističe " + Util.timeUntilGet(singleItem.time_expire)}
                    </div>
                  </div>
                </div>
                <div className="org_single_item_box">
                  <div className="org_single_item_header org_single_item_header_adjust">
                    Količina
                  </div>
                  <div className="org_single_item_value org_single_quantity">
                    <div
                      className="org_single_item_quantity_btn"
                      onClick={() => {
                        this.removeQuantity(i);
                      }}
                    >
                      -
                    </div>
                    <div className="org_single_item_input_container">
                      <input
                        type="text"
                        className="org_single_item_input"
                        value={singleItem.quantity}
                        onChange={(event) => {
                          this.updateQuantity(event, i);
                        }}
                      />
                    </div>
                    <div
                      className="org_single_item_quantity_btn"
                      onClick={() => {
                        this.addQuantity(i);
                      }}
                    >
                      +
                    </div>
                  </div>
                </div>
                <div className="org_single_item_box">
                  <div className="org_single_item_header org_single_item_header_adjust">
                    Prodatih
                  </div>
                  <div
                    className={
                      "org_single_item_value " +
                      (singleItem.soldCount ? " org_soldmore" : "")
                    }
                  >
                    {!singleItem.soldCount ? "-" : singleItem.soldCount}
                  </div>
                </div>
                <div className="org_single_item_box org_single_item_last">
                  <Link to={"/zamjeniproizvod/" + singleItem.product_id}>
                    <div className="org_single_item_delete_button">
                      Izmijeni
                    </div>
                  </Link>
                  {singleItem.quantity > 0 && (
                    <div
                      className="org_single_item_delete_button org_single_item_set_sold_button"
                      onClick={() => {
                        this.setSold(singleItem);
                      }}
                    >
                      Označi kao prodat
                    </div>
                  )}
                  <div
                    className="org_single_item_delete_buttony"
                    onClick={() => {
                      this.removeAdd(singleItem.product_id);
                    }}
                  >
                    Obriši
                  </div>
                </div>
              </div>
            </div>
          )
          //: ''
        )}
        {this.state.userProducts.length > 0 &&
          this.state.max_page > 0 &&
          !this.state.loading_products && (
            <div className="org_bottom_buttons_container">
              {this.state.page_number > 0 && (
                <div
                  className="org_add_substract_page_button"
                  onClick={() => this.switchPage("substract")}
                >
                  Nazad
                </div>
              )}
              <div
                className="org_page_number_container"
                style={{
                  width:
                    this.state.max_page < 8
                      ? this.state.max_page * 25 + "px"
                      : 265 + "px",
                }}
              >
                {this.state.page_number >
                  Math.floor(this.state.pages_count.length / 2) &&
                  this.state.max_page > 8 && (
                    <div
                      className="org_page_number"
                      onClick={() => this.switchPage(0)}
                    >
                      1 ...
                    </div>
                  )}
                {this.state.pages_count.map((onePage, i) => (
                  <div
                    key={i}
                    className={
                      "org_page_number" +
                      (this.state.page_number + 1 == onePage.page_number
                        ? " page_number_current"
                        : "")
                    }
                    onClick={() => this.switchPage(onePage.page_number - 1)}
                  >
                    {onePage.page_number}
                  </div>
                ))}
                {this.state.page_number <
                  this.state.max_page -
                    Math.floor(this.state.pages_count.length / 2) &&
                  this.state.max_page > 8 && (
                    <div
                      className="org_page_number"
                      onClick={() => this.switchPage(this.state.max_page)}
                    >
                      ... {this.state.max_page + 1}
                    </div>
                  )}
              </div>
              {this.state.page_number != this.state.max_page && (
                <div
                  className="org_add_substract_page_button"
                  onClick={() => this.switchPage("add")}
                >
                  Dalje
                </div>
              )}
            </div>
          )}

        <div
          className={
            "loader_holder" + (this.state.loading_products ? " active" : "")
          }
        >
          <div className="loader_big"></div>
        </div>
      </div>
    );
  }
}

export default OrgProducts;
